import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth
export const authAPI = {
  login: (credentials) => axios.post(`${API}/auth/login`, credentials),
  register: (userData) => axios.post(`${API}/auth/register`, userData),
  me: () => axios.get(`${API}/auth/me`),
};

// Settings
export const settingsAPI = {
  get: () => axios.get(`${API}/settings`),
  update: (data) => axios.put(`${API}/settings`, data),
};

// Users
export const usersAPI = {
  list: (role) => axios.get(`${API}/users`, { params: { role } }),
  get: (id) => axios.get(`${API}/users/${id}`),
};

// Customers
export const customersAPI = {
  list: () => axios.get(`${API}/customers`),
  get: (id) => axios.get(`${API}/customers/${id}`),
  create: (data) => axios.post(`${API}/customers`, data),
  update: (id, data) => axios.put(`${API}/customers/${id}`, data),
};

// Resources
export const resourcesAPI = {
  list: (type) => axios.get(`${API}/resources`, { params: { type } }),
  create: (data) => axios.post(`${API}/resources`, data),
  update: (id, data) => axios.put(`${API}/resources/${id}`, data),
  delete: (id) => axios.delete(`${API}/resources/${id}`),
};

// Services
export const servicesAPI = {
  list: (isActive) => axios.get(`${API}/services`, { params: { is_active: isActive } }),
  listPaginated: (params) => axios.get(`${API}/services/paginated`, { params }),
  get: (id) => axios.get(`${API}/services/${id}`),
  create: (data) => axios.post(`${API}/services`, data),
  update: (id, data) => axios.put(`${API}/services/${id}`, data),
  delete: (id) => axios.delete(`${API}/services/${id}`),
  duplicate: (id) => axios.post(`${API}/services/${id}/duplicate`),
  bulkUpdate: (payload) => axios.post(`${API}/services/bulk-update`, payload),
};

// Appointments
export const appointmentsAPI = {
  list: (params) => axios.get(`${API}/appointments/with-details`, { params }),
  create: (data) => axios.post(`${API}/appointments`, data),
  checkIn: (id) => axios.put(`${API}/appointments/${id}/check-in`),
  cancel: (id) => axios.put(`${API}/appointments/${id}/cancel`),
};

// Waitlist
export const waitlistAPI = {
  list: (serviceId) => axios.get(`${API}/waitlist`, { params: { service_id: serviceId } }),
  add: (data) => axios.post(`${API}/waitlist`, data),
};

// Subscriptions
export const subscriptionsAPI = {
  list: (customerId) => axios.get(`${API}/subscriptions`, { params: { customer_id: customerId } }),
  create: (data) => axios.post(`${API}/subscriptions`, data),
};

// Payments
export const paymentsAPI = {
  list: (customerId) => axios.get(`${API}/payments`, { params: { customer_id: customerId } }),
  create: (data) => axios.post(`${API}/payments`, data),
};

// Campaigns
export const campaignsAPI = {
  list: () => axios.get(`${API}/campaigns`),
  create: (data) => axios.post(`${API}/campaigns`, data),
};

// Coupons
export const couponsAPI = {
  list: () => axios.get(`${API}/coupons`),
  create: (data) => axios.post(`${API}/coupons`, data),
};

// Staff
export const staffAPI = {
  list: () => axios.get(`${API}/staff`),
  create: (data) => axios.post(`${API}/staff`, data),
};

// Dashboard
export const dashboardAPI = {
  stats: () => axios.get(`${API}/dashboard/stats`),
};

// Invoice settings
export const invoiceSettingsAPI = {
  get: () => axios.get(`${API}/invoice-settings`),
  update: (data) => axios.put(`${API}/invoice-settings`, data),
};
